import reducer from "./reducer";
export { default as AlertsSettings } from "./components/index";
export { default as alertsSettingsReducerName } from "./constants";
export default reducer;
